<template>
  <div class="home relative">
    <div class="huilv">当前汇率：1美元={{ huilv }}人民币</div>
    <div class="flex wrap" v-if="goodslist.length != 0">
      <div class="goods-box" v-for="(item, index) in goodslist" :key="index">
        <img class="img" :src="item.img" alt="" />
        <div class="title-box">
          <div class="goods-title">{{ item.title }}</div>
          <div class="msg-box flex aCenter jBetween">
            <div>
              <span class="moeny">$</span>
              <span class="price">{{ item.price }}</span>
              <!-- <span class="XG">/</span>
              <span class="HKD">RMB</span>
              <span class="true_price">{{ item.true_price }}</span> -->
            </div>
            <div
              class="buynow"
              @click="buynow(item.id, item.price, yue, item.true_price, huilv)"
            >
              立即购买
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 没记录的时候 -->
    <div class="emp-box column aCenter jCenter" v-else>
      <img src="../../assets/img/bg_jilu.png" alt="" />
      <div class="zwjl">暂无数据</div>
    </div>
    <!-- 立即购买 -->
    <!-- <div class="buy absolute"></div> -->
  </div>
</template>

<script>
import Index from "./Index";
import { goodslistApi } from "../../network/api";
export default {
  name: "Home",
  mixins: [Index],
  created() {
    let formdata = {
      page: 1,
      limit: 1000,
      token: this.$store.state.userinfo.token,
    };
    goodslistApi(formdata)
      .then((res) => {
        console.log(res);
        this.goodslist = res.data.data.list;
        this.yue = res.data.data.money;
        this.huilv = res.data.data.huilv;
      })
      .catch();
  },
};
</script>
<style scoped src="./Home.css"></style>
